var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecommendationsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.365,
    height: 24.496,
    viewBox: "0 0 19.365 24.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3488",
    "data-name": "Groupe 3488",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2011",
    "data-name": "Trac\\xE9 2011",
    d: "M-289.117,2719.449a1.986,1.986,0,0,0,1.919,2.047,1.986,1.986,0,0,0,1.919-2.047c0-4.344-2.764-8.141-6.572-9.03a8.088,8.088,0,0,0-7.17,1.771,9.217,9.217,0,0,0-3.159,7.024v13.438a1.986,1.986,0,0,0,1.919,2.047,1.986,1.986,0,0,0,1.919-2.047v-13.437a5.034,5.034,0,0,1,1.727-3.835,4.445,4.445,0,0,1,3.945-.961A5.019,5.019,0,0,1-289.117,2719.449Z",
    transform: "translate(302.181 -2710.202)",
    fill: "#b9b9b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2012",
    "data-name": "Trac\\xE9 2012",
    d: "M-259.148,2769.578l-6.191-6.022a2.054,2.054,0,0,0-2.905.04,2.054,2.054,0,0,0,.04,2.905l6.191,6.022a2.047,2.047,0,0,0,1.432.582,2.049,2.049,0,0,0,1.473-.622A2.055,2.055,0,0,0-259.148,2769.578Z",
    transform: "translate(277.891 -2748.609)",
    fill: "#b9b9b9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationsIcon);
export default __webpack_public_path__ + "static/media/recommendationsIcon.3a4edb43ec6b01012fa2b494f9ba4086.svg";
export { ForwardRef as ReactComponent };